import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import React from 'react';
import { Roles } from 'globals/enums';
import { appRoutesEndpoints } from './appRoutesEndpoints';
import ChangePassword from 'pages/WCPages/ChangePassword/ChangePassword';
import { AllResidents, ResidentDashboard, ResidentSubPages, } from 'pages/FacilityPages';
import { facilitySlugs } from 'globals/global.constants';
import { SubHeader } from 'common/SubHeader';
import FacilityHomeScreen from 'pages/FacilityPages/FacilityHomeScreen';
import FacilityDashboard from 'pages/FacilityPages/FacilityDashboard/FacilityDashboard.component';
import UnauthorizedAccess from 'common/UnauthorizedAccess';
import { useAppSelector } from 'hooks/reduxHooks';
import DeviceInfoComponent from 'pages/WCPages/Admin/DeviceInfo/DeviceInfo.component';
import FacilityCareDashboard from 'pages/FacilityPages/FacilityHomeScreen/FacilityCareDashboard';
import { useParams, useLocation } from 'react-router-dom';
var Home = React.lazy(function () { return import('pages/WCPages/Home'); });
var TaskManagement = React.lazy(function () { return import('pages/WCPages/TaskManagement/taskManagement.component'); });
var DeviceHealthManagement = React.lazy(function () { return import('pages/WCPages/DeviceHealth/DeviceHealthManagement'); });
var CareDashboard = React.lazy(function () { return import('pages/WCPages/Home/CareDashboard.component'); });
var CaseManagement = React.lazy(function () { return import('pages/WCPages/Home/CaseManagement/CaseManagement'); });
var SeniorContainer = React.lazy(function () { return import('pages/WCPages/SeniorContainer'); });
var Admin = React.lazy(function () { return import('pages/WCPages/Admin'); });
var AddUserPage = React.lazy(function () { return import('pages/WCPages/AddUser'); });
var WellnessDashboard = React.lazy(function () { return import('pages/WCPages/WellnessDashboard'); });
var AllCallSchedule = React.lazy(function () { return import('pages/WCPages/AllCallSchedule'); });
var LoginPage = React.lazy(function () { return import('pages/WCPages/Login'); });
var ChoosePassword = React.lazy(function () { return import('pages/WCPages/ChoosePassword'); });
var ForgotPassword = React.lazy(function () { return import('pages/WCPages/ForgotPassword'); });
var ForgotPasswordVerification = React.lazy(function () { return import('pages/WCPages/ForgotPassword/ForgotPasswordVerification'); });
var ProtectedRoute = function (_a) {
    var allowedRoles = _a.allowedRoles, Component = _a.Component;
    var tab = useParams().tab;
    var location = useLocation();
    var userRoles = useAppSelector(function (state) { return state.auth.roleConfig.role; });
    var normalizedUserRoles = Array.isArray(userRoles)
        ? userRoles.map(function (role) { return role.toLowerCase(); })
        : typeof userRoles === "string"
            ? [userRoles.toLowerCase()]
            : [];
    var normalizedAllowedRoles = allowedRoles.map(function (role) { return role.toLowerCase(); });
    var isAuthorized = normalizedUserRoles.some(function (role) {
        return normalizedAllowedRoles.includes(role);
    });
    var hasWarehouseRestriction = normalizedUserRoles.includes(Roles.WarehouseEmployee.toLowerCase()) &&
        tab !== "onboarding-info" &&
        location.pathname !== "/add-user";
    if (!isAuthorized || hasWarehouseRestriction) {
        return _jsx(UnauthorizedAccess, {});
    }
    return _jsx(Component, {});
};
var AddUserWrapper = function () { return (_jsx(ProtectedRoute, { allowedRoles: [Roles.Admin, Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.Admin_WellnessServices], Component: AddUserPage })); };
var SeniorWrapper = function () { return (_jsx(ProtectedRoute, { allowedRoles: [Roles.Admin, Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.Admin_WellnessServices, Roles.BPO_CareUser], Component: SeniorContainer })); };
/** WC Private routes */
export var privateRoutesList = [
    {
        meta: {
            title: 'Admin',
            description: '',
        },
        path: "".concat(appRoutesEndpoints.admin.baseRoute, "/*"),
        component: _jsx(Admin, {}),
        requiredRoles: [Roles.Admin, Roles.BDM, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Task Management',
            description: '',
        },
        path: appRoutesEndpoints.taskManagement,
        component: _jsx(TaskManagement, {}),
        requiredRoles: [Roles.Admin, Roles.Admin_WellnessServices, Roles.CareAgent, Roles.BPO_CareUser],
    },
    {
        meta: {
            title: 'Home',
            description: '',
        },
        path: appRoutesEndpoints.homePage,
        component: _jsx(Home, {}),
        requiredRoles: [Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.BPO_CareUser],
    },
    {
        meta: {
            title: 'Care Dashboard',
            description: '',
        },
        path: appRoutesEndpoints.careDashboard,
        component: _jsx(CareDashboard, {}),
        requiredRoles: [Roles.CareAgent, Roles.Admin, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Case Management',
            description: '',
        },
        path: appRoutesEndpoints.caseManagement,
        component: _jsx(CaseManagement, {}),
        requiredRoles: [Roles.CareAgent, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Add User',
            description: '',
        },
        path: '/add-user',
        component: _jsx(AddUserWrapper, {}),
        requiredRoles: [Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.FACILITY_AGENT],
    },
    {
        meta: {
            title: 'Wellness Dasboard',
            description: '',
        },
        path: '/senior/:seniorID/:accountID/:timezone/wellness-dashboard',
        component: (_jsxs(_Fragment, { children: [_jsx(SubHeader, {}), _jsx(WellnessDashboard, {})] })),
        requiredRoles: [Roles.CareAgent],
    },
    {
        meta: {
            title: 'Call Schedule',
            description: '',
        },
        path: '/call-schedule',
        component: _jsx(AllCallSchedule, {}),
        requiredRoles: [Roles.CareAgent],
    },
    {
        meta: {
            title: 'Senior Dashboard',
            description: '',
        },
        path: '/senior/:seniorID/:accountID/:timezone/:tab/*',
        component: _jsx(SeniorWrapper, {}),
        requiredRoles: [Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.FACILITY_AGENT, Roles.BPO_CareUser],
    },
    {
        meta: {
            title: 'Device Info',
            description: '',
        },
        path: appRoutesEndpoints.deviceInfo,
        component: _jsx(DeviceInfoComponent, {}),
        requiredRoles: [
            Roles.CareAgent,
            Roles.Admin,
            Roles.Admin_WellnessServices,
            Roles.WarehouseEmployee,
        ],
    },
    {
        meta: {
            title: 'Device health Management',
            description: '',
        },
        path: appRoutesEndpoints.devicehealth,
        component: _jsx(DeviceHealthManagement, {}),
        requiredRoles: [
            Roles.Admin,
            Roles.Admin_WellnessServices,
            Roles.CareAgent,
            Roles.BPO_CareUser,
        ],
    },
    {
        meta: {
            title: 'Change Password',
            description: '',
        },
        path: '/change-password',
        component: _jsx(ChangePassword, {}),
        requiredRoles: [Roles.CareAgent, Roles.WarehouseEmployee, Roles.BDM, Roles.FACILITY_AGENT, Roles.BPO_CareUser],
    },
];
/** WC Private routes */
/** Public routes */
export var publicRoutesList = [
    {
        meta: {
            title: 'Login',
            description: '',
        },
        path: '/login',
        component: _jsx(LoginPage, {}),
    },
    {
        meta: {
            title: 'Choose Password',
            description: '',
        },
        path: '/choose-password',
        component: _jsx(ChoosePassword, {}),
    },
    {
        meta: {
            title: 'Forgot Password',
            description: '',
        },
        path: '/forgot-password',
        component: _jsx(ForgotPassword, {}),
    },
    {
        meta: {
            title: 'Forgot Password',
            description: '',
        },
        path: '/forgot-password-verification',
        component: _jsx(ForgotPasswordVerification, {}),
    },
];
/** Public routes */
/** Agency Routes */
var facilityManagement = facilitySlugs.facilityManagement, facilityHomePage = facilitySlugs.facilityHomePage, facilityResident = facilitySlugs.facilityResident, residentDashboard = facilitySlugs.residentDashboard, accountID = facilitySlugs.accountID, timezone = facilitySlugs.timezone, subRoute = facilitySlugs.subRoute;
export var facilityRoutesList = [
    {
        meta: {
            title: 'Agency',
            description: '',
        },
        path: "/".concat(facilityManagement),
        component: _jsx("div", { children: "Agency Management" }),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.BDM, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Agency Home',
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage),
        component: _jsx(FacilityHomeScreen, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Agency Care',
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage, "/facilityCare"),
        component: _jsx(FacilityCareDashboard, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Agency Dashboard',
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage, "/facilityDashboard"),
        component: _jsx(FacilityDashboard, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.BDM],
    },
    {
        meta: {
            title: 'Agency Clients',
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage, "/:").concat(facilityResident, "?"),
        component: _jsx(AllResidents, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            title: 'Client Dashboard',
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage, "/:").concat(facilityResident, "?/:").concat(residentDashboard, "/:").concat(accountID, "/:").concat(timezone, "/"),
        component: _jsx(ResidentDashboard, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
    },
    {
        meta: {
            description: '',
        },
        path: "/".concat(facilityManagement, "/:").concat(facilityHomePage, "/:").concat(facilityResident, "?/:").concat(residentDashboard, "/:").concat(accountID, "/:").concat(timezone, "?/:").concat(subRoute, "?"),
        component: _jsx(ResidentSubPages, {}),
        requiredRoles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
    },
];
